import { defineClassifierEntity, transformClassifierColumns } from '@juvare/platform-sdk-react/backend/features/classifiers';
import { classifierColumns } from '@juvare/platform-sdk-react/backend/features/classifiers/shared';
import { defineColumns } from '@juvare/platform-shared/features/storage';
import { defaultRepeatCallValues } from './defaults';
export const repeatCallEntityName = 'repeatCall';
const repeatCallColumns = defineColumns(Object.assign(Object.assign({}, classifierColumns), { value: {
        type: 'number-required',
        index: true,
    }, search: {
        type: 'full-text-search-required',
        language: 'english',
    } }));
export function defineRepeatCallClassifier() {
    return defineClassifierEntity({
        entity: {
            version: 1,
            columns: repeatCallColumns,
            onMigrate: (params) => params.oldData,
            onTransformColumns: (context, params) => {
                return Object.assign(Object.assign({}, transformClassifierColumns(params)), { value: params.data.value, search: [params.data.name, params.data.value, params.data.status].join(' ') });
            },
            onAnonymousAuthGet: (appState, response) => response,
            onAnonymousAuthList: (appState, response) => response,
        },
        defaultData: defaultRepeatCallValues,
    });
}
